/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNose = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m14.388 2.96-6.5 12.5-.014.026c-.18.325-.305.792-.23 1.162a.838.838 0 0 0 .24.448c.142.138.396.306.852.431l2.46.492c.57.115 1.37.437 2.044 1.057.7.644 1.26 1.61 1.26 2.924h-2c0-.686-.273-1.137-.614-1.451a2.431 2.431 0 0 0-1.081-.569l-2.5-.5-.032-.005-.032-.01c-.728-.194-1.318-.51-1.76-.945a2.84 2.84 0 0 1-.798-1.477c-.198-.98.116-1.927.431-2.504l6.5-12.5z" />
        <path d="M18.366 13.5c.88 1.525 1.09 2.979.386 4.04-.711 1.073-2.028 1.255-3.068.908-.73-.243-1.964-.614-3.029-.927a353.57 353.57 0 0 0-1.362-.396l-.416-.12-.112-.032-.03-.01-.007-.001h-.002l.548-1.924.001.001h.002l.008.002.03.009.115.033.418.12 1.372.4c1.06.312 2.327.692 3.096.949.46.153.701-.015.769-.117.076-.114.285-.66-.451-1.935z" />
      </g>
    </g>
  </Icon>
);
export { SvgNose as Nose };
